import { Routes } from '@angular/router';
import { adminAuthGuard } from './core/auth/admin-auth.guard';

export const adminRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./auth/admin-login/admin-login').then(m => m.AdminLogin),
  },
  {
    path: '2fa/challenge',
    loadComponent: () =>
      import('./auth/admin-2fa-challenge/admin-2fa-challenge').then(m => m.Admin2FAChallenge),
  },
  {
    path: '2fa/setup',
    loadComponent: () =>
      import('./auth/admin-2fa-setup/admin-2fa-setup').then(m => m.Admin2FASetup),
  },
  {
    path: '',
    canActivate: [adminAuthGuard],
    loadComponent: () =>
      import('./shell/admin-shell').then(m => m.AdminShell),
    loadChildren: () =>
      import('./shell/admin-shell.routes').then(m => m.adminShellRoutes),
  },
  { path: '**', redirectTo: '' },
];
